module.exports = __webpack_public_path__ + "static/matbuu-detail6-1e59a9ef63e37bcdb5de169ddd044406.png";